export default "__VITE_ASSET__CEgovHiJ__"